import { getDefaultDialingCode } from "shared/components/PhoneInput/helpers";
import Context from "shared/util/Context";

// action types
// ----------------------------------------------------------------------------

export const UPDATE_PHONE_NUMBER = "SMS.UPDATE_PHONE_NUMBER";
export const UPDATE_ISO_CODE = "SMS.UPDATE_ISO_CODE";
export const UPDATE_DIALING_CODE = "SMS.UPDATE_DIALING_CODE";


// initial state
// ----------------------------------------------------------------------------
export const INITIAL_STATE = {
	phoneNumber: "",
	dialingCode: "1",
	isoCode: "US",
};

const getInitialState = () => {
	const { isoCode, dialingCode } = getDefaultDialingCode(Context.get("countryCode"));

	return {
		...INITIAL_STATE,
		dialingCode,
		isoCode,
	};
};

// reducer
// ----------------------------------------------------------------------------

export function reducer(state = getInitialState(), action) {
	switch (action.type) {
		case UPDATE_PHONE_NUMBER:
			return {
				...state,
				phoneNumber: action.payload.phoneNumber,
			};

		case UPDATE_ISO_CODE:
			return {
				...state,
				isoCode: action.payload.isoCode,
			};

		case UPDATE_DIALING_CODE:
			return {
				...state,
				dialingCode: action.payload.dialingCode,
			};

		default:
			return state;
	}
}

// action creators
// ----------------------------------------------------------------------------
export const updatePhoneNumber = (phoneNumber) => ({
	type: UPDATE_PHONE_NUMBER,
	payload: {
		phoneNumber,
	},
});

export const updateIsoCode = (isoCode) => ({
	type: UPDATE_ISO_CODE,
	payload: {
		isoCode,
	},
});

export const updateDialingCode = (dialingCode) => ({
	type: UPDATE_DIALING_CODE,
	payload: {
		dialingCode,
	},
});



// WEBPACK FOOTER //
// ./src/ducks/sms.js